export default __webpack_public_path__ + "static/media/airj-s.fa16d812.jpg";